import { render, staticRenderFns } from "./Funnel.vue?vue&type=template&id=687b36f8&scoped=true"
import script from "./Funnel.vue?vue&type=script&lang=js"
export * from "./Funnel.vue?vue&type=script&lang=js"
import style0 from "./Funnel.vue?vue&type=style&index=0&id=687b36f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b36f8",
  null
  
)

export default component.exports